import axios from 'axios';

export const getCommonProcessYn = ({ hspId }) => {
  return axios.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/front/common/process/yn/${hspId}`);
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_DFD_SVC_URL,
});

api.defaults.headers.common['apiKey'] = process.env.REACT_APP_API_KEY;
api.defaults.headers.common['hsp_id'] = process.env.REACT_APP_HSP_ID;

// 요청 인터셉터 추가
api.interceptors.request.use(
  (config) => {
    const commonProcess = sessionStorage.getItem('commonProcess');
    if (commonProcess) {
      try {
        const { headerList } = JSON.parse(commonProcess);
        // 기존 헤더가 있다면 유지하면서 새로운 헤더 추가
        config.headers = {
          ...config.headers,
          ...headerList,
        };
      } catch (error) {
        console.error('Failed to parse commonProcess from sessionStorage:', error);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export { api };
